export const ERROR_PREFIX = 'web_error_';

export const DEFAULT_ERROR_KEY = `${ERROR_PREFIX}unknown_error`;
export const SERVER_RESOURCE_NOT_AVAIL_ERROR_KEY = `web_multiserver_failed_of_connect_subtitle`;
